import type { PrintChecksResponse } from 'pages/VendorsTablePage/components/PrintChecks/types';

export const printChecksTableData: PrintChecksResponse = {
  vendors: [
    {
      vendorNo: '2021',
      vendorName: 'Tommie Turpin',
      invoices: [
        {
          invoiceId: '1-0-1'
        },
        {
          invoiceId: '1-0-2'
        }
      ],
      totalNetAmount: '$231.51'
    },
    {
      vendorNo: '2022',
      vendorName: 'Vladamir Philbrook',
      invoices: [{ invoiceId: '2-1-1' }],
      totalNetAmount: '$123.50'
    }
  ],
  totalOwed: '$355.01',
  totalNoOfVendors: 2
};

export const printChecksSelectedData = [
  {
    invoices: [{ invoiceId: '1-0-2', lockStatus: undefined }],
    totalNetAmount: '$123.50',
    vendorNo: '2021',
    vendorName: 'Tommie Turpin'
  }
];
